import { render, staticRenderFns } from "./ReleaseDetail.vue?vue&type=template&id=80c3455c&"
import script from "./ReleaseDetail.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports